export default __webpack_public_path__ + "static/media/4mm_bag.f1442139.jpg";